import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const ishranaAdapter = createEntityAdapter({});

const initialState = ishranaAdapter.getInitialState();

export const ishraneApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllIshrane: builder.query({
      query: () => ({
        url: "/ishrane",
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
      transformResponse: (responseData) => {
        const loadedfa = responseData.map((fa) => {
          fa.id = fa._id;
          return fa;
        });
        return ishranaAdapter.setAll(initialState, loadedfa);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "Ishrane", id: "LIST" },
            ...result.ids.map((id) => ({ type: "Ishrane", id })),
          ];
        } else return [{ type: "Ishrane", id: "LIST" }];
      },
    }),
    getIshraneNames: builder.query({
      //Sa naminicama ja nzm zasto ih imam ovde
      query: () => ({
        url: "/ishrane/names",
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getIshraneNames_: builder.query({
      //Bez naminica
      query: () => ({
        url: "/ishrane/names_",
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    getLazyIshraneNames: builder.query({
      //Lazy
      query: () => ({
        url: "/ishrane/names",
        validateStatus: (response, result) => {
          return response.status === 200 && !result.isError;
        },
      }),
    }),
    addNewIshrana: builder.mutation({
      query: (initialUserData) => ({
        url: "/ishrane",
        method: "POST",
        body: {
          ...initialUserData,
        },
      }),
      invalidatesTags: [{ type: "Ishrane", id: "LIST" }],
    }),
    updateIshrana: builder.mutation({
      query: (initialUserData) => ({
        url: "/ishrane",
        method: "PATCH",
        body: {
          ...initialUserData,
        },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Ishrane", id: arg.id },
      ],
    }),
    deleteIshrana: builder.mutation({
      query: ({ id }) => ({
        url: `/ishrane`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [
        { type: "Ishrane", id: arg.id },
      ],
    }),
  }),
});

export const {
  useGetAllIshraneQuery,
  useGetIshraneNamesQuery,
  useLazyGetIshraneNamesQuery,
  useGetIshraneNames_Query,
  useUpdateIshranaMutation,
  useAddNewIshranaMutation,
  useDeleteIshranaMutation,
} = ishraneApiSlice;
